import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve image URL: relative `/api/...` paths get prefixed with backend, http(s) URLs pass through.
export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  return `${BACKEND_URL}${u}`;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("hn_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setAuth = (token, user) => {
  localStorage.setItem("hn_token", token);
  localStorage.setItem("hn_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("hn_token");
  localStorage.removeItem("hn_user");
};
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("hn_user") || "null"); }
  catch { return null; }
};
export const getToken = () => localStorage.getItem("hn_token");

// ---------- Admin impersonation helpers ----------
// When an admin impersonates a user we stash their original session under
// `hn_admin_backup` and swap `hn_token` / `hn_user` for the target user's.
// A visible banner (see ImpersonationBanner.jsx) lets the admin exit any time.
export const startImpersonation = (targetToken, targetUser, impMeta) => {
  const adminToken = localStorage.getItem("hn_token");
  const adminUser = localStorage.getItem("hn_user");
  if (adminToken && adminUser) {
    localStorage.setItem("hn_admin_backup", JSON.stringify({ token: adminToken, user: JSON.parse(adminUser) }));
  }
  localStorage.setItem("hn_token", targetToken);
  localStorage.setItem("hn_user", JSON.stringify(targetUser));
  localStorage.setItem("hn_impersonation", JSON.stringify(impMeta || {}));
};
export const stopImpersonation = () => {
  const raw = localStorage.getItem("hn_admin_backup");
  if (!raw) {
    // Nothing to restore — just clear everything so the app doesn't get stuck.
    localStorage.removeItem("hn_token");
    localStorage.removeItem("hn_user");
    localStorage.removeItem("hn_impersonation");
    return null;
  }
  try {
    const backup = JSON.parse(raw);
    localStorage.setItem("hn_token", backup.token);
    localStorage.setItem("hn_user", JSON.stringify(backup.user));
  } catch { /* ignore */ }
  localStorage.removeItem("hn_admin_backup");
  localStorage.removeItem("hn_impersonation");
  return true;
};
export const getImpersonation = () => {
  try { return JSON.parse(localStorage.getItem("hn_impersonation") || "null"); }
  catch { return null; }
};
export const isImpersonating = () => !!localStorage.getItem("hn_admin_backup");
